export default __webpack_public_path__ + "static/media/facturacion.96ab4aba.svg";